<template>
    <div>
        <div id="cucc-verified">
            <!-- 顶部品牌头部 -->
            <div class="brand-header">
                <div class="header-bg"></div>
                <div class="header-content">
                    <div class="brand-logo">
                        <span class="logo-icon">联通</span>
                    </div>
                    <h1 class="page-title">实名认证</h1>
                    <p class="page-subtitle">联通实名登记系统</p>
                </div>
            </div>
            <!-- 步骤指示器 -->
            <div class="step-indicator">
                <div class="step-item active">
                    <div class="step-circle">1</div>
                    <span class="step-label">填写信息</span>
                </div>
                <div class="step-line"></div>
                <div class="step-item">
                    <div class="step-circle">2</div>
                    <span class="step-label">身份验证</span>
                </div>
                <div class="step-line"></div>
                <div class="step-item">
                    <div class="step-circle">3</div>
                    <span class="step-label">完成认证</span>
                </div>
            </div>

            <!-- 主表单区域 -->
            <div class="main-content">
                <!-- 法规提示 -->
                <div class="notice-bar">
                    <van-icon name="info-o" class="notice-icon" />
                    <span>根据工信部《电话用户真实身份信息登记规定》，请如实填写以下信息完成实名认证</span>
                </div>
                <!-- 表单卡片 -->
                <div class="form-card">
                    <div class="card-title">
                        <span class="title-line"></span>
                        <span>身份信息登记</span>
                    </div>

                    <!-- <div class="form-item">
                    <label class="form-label">
                        <van-icon name="label-o" class="label-icon" />
                        ICCID卡号
                    </label>
                    <div class="input-wrapper" :class="{ 'input-disabled': isFirst == 2 }">
                        <van-field
                            v-model="verifiedInfo.iccid"
                            clearable
                            placeholder="请输入ICCID卡号"
                            :disabled="isFirst == 2"
                            class="custom-field"
                        />
                    </div>
                </div> -->

                    <div class="form-item">
                        <label class="form-label">
                            <van-icon name="user-o" class="label-icon" />
                            真实姓名
                        </label>
                        <div class="input-wrapper" :class="{ 'input-disabled': isFirst == 2 }">
                            <van-field v-model="verifiedInfo.name" clearable placeholder="请输入您的真实姓名"
                                :disabled="isFirst == 2" class="custom-field" />
                        </div>
                    </div>

                    <div class="form-item">
                        <label class="form-label">
                            <van-icon name="idcard" class="label-icon" />
                            身份证号码
                        </label>
                        <div class="input-wrapper" :class="{ 'input-disabled': isFirst == 2 }">
                            <van-field v-model="verifiedInfo.idcard" clearable maxlength="18" placeholder="请输入18位身份证号码"
                                :disabled="isFirst == 2" class="custom-field" />
                        </div>
                    </div>

                    <div class="form-item">
                        <label class="form-label">
                            <van-icon name="phone-o" class="label-icon" />
                            联系电话
                        </label>
                        <div class="input-wrapper" :class="{ 'input-disabled': isFirst == 2 }">
                            <van-field v-model="verifiedInfo.userPhone" maxlength="11" clearable
                                placeholder="请输入11位手机号码" :disabled="isFirst == 2" class="custom-field" />
                        </div>
                    </div>
                </div>

                <!-- 温馨提示卡片 -->
                <div class="tips-card">
                    <div class="tips-header">
                        <van-icon name="warning-o" class="tips-icon" />
                        <span class="tips-title">温馨提示</span>
                    </div>
                    <ul class="tips-list">
                        <li>
                            <span class="dot"></span>
                            请确保您的实名手机号、姓名、身份证信息三者保持一致，否则将认证失败
                        </li>
                    </ul>
                </div>

                <!-- 提交按钮 -->
                <div class="submit-section">
                    <div class="agreement-box" v-if="isFirst != 2">
                        <van-checkbox v-model="agreed" shape="square" icon-size="15px">
                            <span class="agreement-text">
                                我已阅读并同意
                                <span class="link-text" @click.stop="showAgreementPopup('service')">《用户服务协议》</span>和
                                <span class="link-text" @click.stop="showAgreementPopup('privacy')">《隐私政策》</span>
                            </span>
                        </van-checkbox>
                    </div>

                    <button class="submit-btn" :class="{ 'btn-disabled': !agreed && isFirst != 2 }"
                        :disabled="!agreed && isFirst != 2" @click.prevent="sureVerifiedHandler">
                        <van-icon name="checked" v-if="agreed || isFirst == 2" />
                        {{ isFirst == 2 ? '支付实名费用' : '立即提交认证' }}
                    </button>
                </div>

                <!-- 底部安全保障 -->
                <div class="security-footer">
                    <div class="security-item">
                        <van-icon name="shield-o" />
                        <span>数据加密传输</span>
                    </div>
                    <div class="security-item">
                        <van-icon name="lock" />
                        <span>隐私安全保障</span>
                    </div>
                    <div class="security-item">
                        <van-icon name="certificate" />
                        <span>实名合规认证</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 协议弹窗 -->
        <div class="agreement-popup-overlay" v-if="showAgreement" @click.self="showAgreement = false">
            <div class="agreement-popup">
                <div class="agreement-popup-header">
                    <span>{{ agreementType === 'service' ? '用户服务协议' : '隐私政策' }}</span>
                    <van-icon name="cross" class="agreement-popup-close" @click="showAgreement = false" />
                </div>
                <div class="agreement-popup-body" v-if="agreementType === 'service'">
                    <h3>一、服务条款的接受</h3>
                    <p>欢迎使用本平台提供的通信服务。本协议是您与本平台之间关于使用本平台服务所订立的协议。请您仔细阅读本协议，您勾选"我已阅读并同意"即表示您已充分阅读、理解并接受本协议的全部内容。</p>
                    <h3>二、用户权利与义务</h3>
                    <p>1. 用户有权根据本协议的规定使用本平台提供的各项服务。</p>
                    <p>2. 用户应保证提供的个人信息真实、准确、完整，并在信息变更时及时更新。</p>
                    <p>3. 用户应妥善保管账号信息和密码，因密码泄露导致的损失由用户自行承担。</p>
                    <p>4. 用户承诺不利用本平台从事违法违规活动，不得干扰本平台的正常运营。</p>
                    <h3>三、服务使用规范</h3>
                    <p>1. 用户在使用通信服务过程中，应遵守国家相关法律法规及政策规定。</p>
                    <p>2. 用户不得利用本服务进行骚扰、诈骗、传播违法信息等行为。</p>
                    <p>3. 平台有权对违规账号采取限制、暂停或终止服务等措施。</p>
                    <h3>四、免责声明</h3>
                    <p>1. 因不可抗力、系统维护、网络故障等原因导致的服务中断，平台不承担责任。</p>
                    <p>2. 用户因使用本服务与其他第三方产生的纠纷，由用户自行解决。</p>
                    <p>3. 本协议最终解释权归本平台所有。</p>
                    <h3>五、其他</h3>
                    <p>本协议条款的任何变更，平台将通过适当方式通知用户。若用户继续使用本服务，视为接受修改后的协议。</p>
                </div>
                <div class="agreement-popup-body" v-else>
                    <h3>一、信息收集</h3>
                    <p>1. 我们收集您的个人信息是为了向您提供优质的通信服务，包括但不限于实名认证、业务办理、客户服务等。</p>
                    <p>2. 收集的信息类型包括：姓名、身份证号码、手机号码、ICCID卡号等必要信息。</p>
                    <p>3. 我们仅在法律法规允许的范围内收集和使用您的个人信息。</p>
                    <h3>二、信息使用</h3>
                    <p>1. 您的个人信息将用于完成实名认证、提供通信服务、改善服务质量等目的。</p>
                    <p>2. 未经您的明确同意，我们不会将您的个人信息用于其他商业用途。</p>
                    <p>3. 我们仅在实现服务目的所必需的最短时间内保留您的个人信息。</p>
                    <h3>三、信息保护</h3>
                    <p>1. 我们采用业界通行的安全技术和措施保护您的个人信息安全，包括数据加密传输、访问控制等。</p>
                    <p>2. 我们建立了完善的数据安全管理制度，确保您的信息不被泄露、篡改或滥用。</p>
                    <p>3. 如发生个人信息安全事件，我们将及时告知您并采取有效措施。</p>
                    <h3>四、用户权利</h3>
                    <p>1. 您有权查询、更正您的个人信息。</p>
                    <p>2. 您有权要求删除您的个人信息（法律法规另有规定的除外）。</p>
                    <p>3. 您有权撤回对个人信息收集的同意。</p>
                    <h3>五、未成年人保护</h3>
                    <p>我们高度重视未成年人个人信息的保护。未满18周岁的用户应在监护人陪同下阅读本政策并取得监护人同意。</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { wxRequest, verified } from '@/api/user'
import aes from "@/utils/aes";
import { Dialog, Toast } from 'vant';
export default {
    data() {
        return {
            leshuaPay: localStorage.getItem('leshuaPay'),
            verifiedInfo: {
                iccid: localStorage.getItem('iccid'),
                name: '',
                userPhone: '',
                idcard: '',
                smsCode: '1',
                sysAuth: '1',
                isFirst: 0,
                btnTxt: '发送验证码',
            },
            bindFlag: false,
            isFirst: 0,
            agreed: false,
            showAgreement: false,
            agreementType: ''
        }
    },
    methods: {
        showAgreementPopup(type) {
            this.agreementType = type;
            this.showAgreement = true;
        },
        getSmsCode() {
            const rulut = this.$getRsaCode(this.verifiedInfo.userPhone) //加密
            var data = {
                userPhone: rulut
            }
            wxRequest("bindPhone/sms/code", data, "post").then(res => {
                if (res.data.code == 200) {
                    var n = 60;
                    this.verifiedInfo.btnTxt = '重新发送' + n + 's';
                    let timer = window.setInterval(() => {
                        n--;
                        this.verifiedInfo.btnTxt = '重新发送' + n + 's';
                        if (n < 1) {
                            window.clearInterval(timer);
                            this.verifiedInfo.btnTxt = '发送验证码';
                        }
                    }, 1000)
                } else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            })
        },
        getVerifiedInfoHandler() {
            var data = {
                iccid: localStorage.getItem('iccid')
            }
            wxRequest('bindPhone/phone/info/iccid', data, 'post').then(res => {
                if (res.data.code == 200 && res.data.data) {
                    for (var key in this.verifiedInfo) {
                        this.verifiedInfo[key] = res.data.data[key];
                    }
                }
            })
        },
        sureVerifiedHandler() {
            if (!this.agreed) {
                Dialog.alert({ title: "提示", message: "请先阅读并同意用户服务协议和隐私政策" });
                return;
            }
            wxRequest("bindPhone/phone", this.verifiedInfo, "post").then(res => {
                if (res.data.code == 200) {
                    const loadingToast = Toast.loading({
                        message: '实名认证中...',
                        forbidClick: true,
                        duration: 0
                    });
                    setTimeout(() => {
                        loadingToast.clear();
                        Dialog.alert({
                            title: '提示',
                            message: '实名认证成功'
                        }).then(() => {
                            this.$router.push('/user/home');
                        });
                    }, 2000);
                } else {
                    this.$messagebox.alert(res.data.message);
                }
            })
        },
    },
    created() {
    },

    mounted() {
    },
    computed: {
        bindFlag() {
            if (this.verifiedInfo.userPhone.length == 11) {
                return false;
            } else {
                return true;
            }
        },
        smsFlag() {
            if (this.verifiedInfo.userPhone.length == 11 && this.verifiedInfo.btnTxt == '发送验证码') {
                return false;
            } else {
                return true;
            }
        },

    },
}
</script>
<style lang="less">
#cucc-verified {
    min-height: 100vh;
    background: #f5f6fa;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", sans-serif;
    padding-bottom: 30px;

    // ========== 品牌头部 ==========
    .brand-header {
        position: relative;
        background: linear-gradient(135deg, #c41230 0%, #e60012 50%, #d41025 100%);
        padding: 0 0 30px 0;
        overflow: hidden;

        .header-bg {
            position: absolute;
            top: -40px;
            right: -30px;
            width: 180px;
            height: 180px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.06);
        }

        .header-content {
            position: relative;
            z-index: 1;
            text-align: center;
            padding: 35px 20px 25px;

            .brand-logo {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 12px;

                .logo-icon {
                    display: inline-block;
                    background: #fff;
                    color: #c41230;
                    font-size: 14px;
                    font-weight: 700;
                    padding: 8px 16px;
                    border-radius: 6px;
                    letter-spacing: 2px;
                }
            }

            .page-title {
                font-size: 24px;
                font-weight: 700;
                color: #fff;
                margin: 0 0 8px 0;
                letter-spacing: 3px;
            }

            .page-subtitle {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.85);
                margin: 0;
                letter-spacing: 1px;
            }
        }
    }

    // ========== 步骤指示器 ==========
    .step-indicator {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 30px;
        background: #fff;
        margin: -15px 16px 0;
        border-radius: 12px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
        position: relative;
        z-index: 2;

        .step-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 6px;

            .step-circle {
                width: 28px;
                height: 28px;
                border-radius: 50%;
                background: #e8e8e8;
                color: #999;
                font-size: 13px;
                font-weight: 600;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.3s ease;
            }

            .step-label {
                font-size: 11px;
                color: #999;
                white-space: nowrap;
            }

            &.active {
                .step-circle {
                    background: linear-gradient(135deg, #c41230, #e60012);
                    color: #fff;
                    box-shadow: 0 2px 8px rgba(198, 18, 48, 0.3);
                }

                .step-label {
                    color: #c41230;
                    font-weight: 600;
                }
            }
        }

        .step-line {
            flex: 1;
            height: 2px;
            background: #e8e8e8;
            margin: 0 8px;
            margin-bottom: 18px;
            border-radius: 1px;
            max-width: 50px;
            min-width: 30px;
        }
    }

    // ========== 主内容区 ==========
    .main-content {
        padding: 16px;

        // 法规提示条
        .notice-bar {
            display: flex;
            align-items: flex-start;
            gap: 8px;
            background: linear-gradient(135deg, #fff8f0, #fff5f5);
            border: 1px solid #ffe0d0;
            border-radius: 8px;
            padding: 10px 12px;
            font-size: 12px;
            color: #b85c2e;
            line-height: 1.6;
            margin-bottom: 12px;

            .notice-icon {
                font-size: 14px;
                color: #e67e22;
                flex-shrink: 0;
                margin-top: 1px;
            }
        }

        // 表单卡片
        .form-card {
            background: #fff;
            border-radius: 12px;
            padding: 20px 16px;
            box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);
            margin-bottom: 12px;

            .card-title {
                font-size: 16px;
                font-weight: 700;
                color: #1a1a1a;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                gap: 8px;

                .title-line {
                    display: inline-block;
                    width: 3px;
                    height: 18px;
                    background: linear-gradient(180deg, #c41230, #e60012);
                    border-radius: 2px;
                }
            }

            .form-item {
                margin-bottom: 16px;

                &:last-child {
                    margin-bottom: 0;
                }

                .form-label {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 6px;

                    .label-icon {
                        font-size: 14px;
                        color: #c41230;
                    }
                }

                .input-wrapper {
                    border: 1px solid #e8e8e8;
                    border-radius: 8px;
                    overflow: hidden;
                    transition: border-color 0.3s ease;

                    &:focus-within {
                        border-color: #c41230;
                        box-shadow: 0 0 0 2px rgba(198, 18, 48, 0.08);
                    }

                    &.input-disabled {
                        background: #fafafa;
                        border-color: #f0f0f0;

                        .custom-field {
                            opacity: 0.7;
                        }
                    }

                    .custom-field {
                        padding: 10px 12px !important;

                        .van-field__body {
                            background: transparent;
                        }

                        .van-field__control {
                            font-size: 14px;
                            color: #333;

                            &::placeholder {
                                color: #c0c0c0;
                            }
                        }
                    }
                }
            }
        }

        // 温馨提示卡片
        .tips-card {
            background: #fff;
            border-radius: 12px;
            padding: 16px;
            box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);
            margin-bottom: 20px;

            .tips-header {
                display: flex;
                align-items: center;
                gap: 6px;
                margin-bottom: 12px;

                .tips-icon {
                    font-size: 15px;
                    color: #e67e22;
                }

                .tips-title {
                    font-size: 14px;
                    font-weight: 600;
                    color: #333;
                }
            }

            .tips-list {
                list-style: none;
                padding: 0;
                margin: 0;

                li {
                    font-size: 12px;
                    color: #888;
                    line-height: 1.8;
                    padding-left: 14px;
                    position: relative;

                    .dot {
                        position: absolute;
                        left: 0;
                        top: 10px;
                        width: 5px;
                        height: 5px;
                        border-radius: 50%;
                        background: #e67e22;
                    }

                    .highlight {
                        color: #c41230;
                        font-weight: 600;
                    }
                }
            }
        }

        // 提交区域
        .submit-section {
            margin-bottom: 20px;

            .agreement-box {
                margin-bottom: 16px;
                padding: 0 4px;

                .agreement-text {
                    font-size: 12px;
                    color: #999;
                }

                .link-text {
                    color: #c41230;
                }
            }

            .submit-btn {
                width: 100%;
                height: 50px;
                background: linear-gradient(135deg, #c41230 0%, #e60012 100%);
                border: none;
                border-radius: 25px;
                color: #fff;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: 2px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                cursor: pointer;
                box-shadow: 0 4px 16px rgba(198, 18, 48, 0.35);
                transition: all 0.3s ease;

                &:active {
                    transform: scale(0.98);
                    opacity: 0.9;
                }

                &.btn-disabled {
                    background: #d0d0d0;
                    box-shadow: none;
                    cursor: not-allowed;

                    &:active {
                        transform: none;
                        opacity: 1;
                    }
                }
            }
        }

        // 安全保障
        .security-footer {
            display: flex;
            justify-content: center;
            gap: 24px;
            padding: 10px 0;

            .security-item {
                display: flex;
                align-items: center;
                gap: 4px;
                font-size: 11px;
                color: #b0b0b0;

                .van-icon {
                    font-size: 13px;
                    color: #c0c0c0;
                }
            }
        }
    }
}

// ========== 协议弹窗 ==========
.agreement-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.25s ease;

    .agreement-popup {
        width: 85%;
        max-height: 70vh;
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        animation: slideUp 0.3s ease;

        .agreement-popup-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 20px;
            border-bottom: 1px solid #f0f0f0;
            background: #fafafa;

            span {
                font-size: 16px;
                font-weight: 600;
                color: #333;
            }

            .agreement-popup-close {
                font-size: 18px;
                color: #999;
                cursor: pointer;

                &:active {
                    color: #666;
                }
            }
        }

        .agreement-popup-body {
            padding: 16px 20px 24px;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;

            h3 {
                font-size: 14px;
                font-weight: 600;
                color: #333;
                margin: 16px 0 8px 0;

                &:first-child {
                    margin-top: 0;
                }
            }

            p {
                font-size: 13px;
                color: #666;
                line-height: 1.8;
                margin: 0 0 4px 0;
                text-indent: 0;
            }
        }
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        transform: translateY(30px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>
